import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, tomos, tomoIncludes } from '../data/tomos';
export function Tomos() {
  return <section aria-label="Los tomos del manual" className="bg-ink" data-id="element-170" data-mp="1h2udoj7py5gp">
      <div className="mx-auto max-w-6xl px-5 py-12" data-id="element-171" data-mp="1h573fijpxk4b">
        <div className="text-center" data-id="element-172" data-mp="1cc456x3zxmhs">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-rojo-soft" data-id="element-173" data-mp="1cb2wgzagdc38">
            🏆 CÓDIGO INFIDELIDAD™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-white sm:text-4xl" data-id="element-174" data-mp="1m2fmrmglru75">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-175" data-mp="200x492fx0agm">+100 páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-176" data-mp="1w03k8k5lfft0">
            {pillars.map(p => <span key={p} className="rounded-full border border-plata/25 bg-plata/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-plata" data-id="element-177" data-mp="5oyyjagtdwph">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-178" data-mp="39p9twdnmd5g7">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06
        }} className="group rounded-2xl border border-white/10 bg-ink-2 p-5 transition-colors duration-200 hover:border-rojo/50" data-id="element-179" data-mp="3eomcgm7gjqcz" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-180" data-mp="1baxxc0ndk2p">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-vino/50 font-display text-lg font-black text-plata" data-id="element-181" data-mp="68ua86dsbms0">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-182" data-mp="27znzjldkrid7">
                  <span aria-hidden="true" data-id="element-183" data-mp="1zzhukkriv0rn">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-184" data-mp="1vz7qjdnaikff">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-plata/20 bg-ink-2 p-6" data-id="element-185" data-mp="29vuq7o6mnop1">
          <p className="text-center font-display text-lg font-black text-plata" data-id="element-186" data-mp="24x9plnngr302">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-187" data-mp="2iw9dgt35jdv6">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/75" data-id="element-188" data-mp="2so5nn2iiiufr">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-rojo-soft" strokeWidth={3} data-id="element-189" data-mp="2npc874jo0tcy" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}